var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPc)?_c('footerPc',{attrs:{"gData":_vm.gData}}):_c('footerMobile',{attrs:{"gData":_vm.gData}})}
var staticRenderFns = []

export { render, staticRenderFns }